import React from "react";
import {
    TableContainer,
    ShiftStartHour,
    ShiftEndHour,
    OtherPoolLink,
    ShiftHourWrapper,
    SlotTitleWrapper,
    SlotCellWrapper,
    ShiftCell,
    ShiftIconWrapper,
    SlotCellOverlay,
    DurationProgressWrapper,
    CourierNameCell,
    JokerCellOverlay
} from "./ResponsiveDataTable.styles";
ThunderboltFilled;
import {ThunderboltFilled} from "@ant-design/icons";
import {Button, Col, Modal, Row, Empty, Tooltip} from "antd";
import {SlotCell} from "../../components/slotCell/SlotCell";
import {useStore} from "../../../../hooks/useStore";
import moment from "moment-timezone";
import {CustomProgress} from "../../components/customProgress/CustomProgress";
import {EmptyMessage} from "../../../_defaultComponents/EmptyMessage/EmptyMessage";
import {useTranslation} from "react-i18next";
import {BookMultipleSlotsModal} from "../../components/bookMultipleSlotsModal/BookMultipleSlotsModal";
import {SelectJokerModal} from "../../components/selectJokerModal/SelectJokerModal";
import {EmptySlotCell} from "../../components/emptySlotCell/EmptySlotCell";
import {SlotCreatePopConfirm} from "../../components/slotCreatePopConfirm/SlotCreatePopConfirm";
const TABLE_PREFIX = "poolCourierShiftTable";
const ResponsiveDataTable = ({
    courierShiftTableDate = {},
    loading,
    filters,
    setFilters,
    recall = () => {}
}) => {
    const stores = useStore();
    const {t} = useTranslation();
    const {allDates = [], courierShifts = [], dailySlots = []} = courierShiftTableDate;

    const [operationModalVisibility, setOperationModalVisibility] = React.useState(false);
    const [selectJokerModalVisibility, setSelectJokerModalVisibility] = React.useState(false);
    const [bookMultipleSlotsModalVisibility, setBookMultipleSlotsModalVisibility] = React.useState(
        false
    );
    const [dateOptions, setDateOptions] = React.useState([]);
    const [courierId, setCourierId] = React.useState();
    const [fullname, setFullname] = React.useState();

    const findInSlotsData = ({courierId, date, shiftHourId}) => {
        if (!courierShifts || !Array.isArray(courierShifts) || courierShifts.length === 0) {
            return null;
        }

        if (courierId === undefined || date === undefined || shiftHourId === undefined) {
            return null;
        }

        // The Courier's Shifts
        const shifts =
            courierShifts?.find(item => item?._id?.toString() === courierId?.toString())?.shifts ||
            [];

        if (!shifts || !Array.isArray(shifts) || shifts?.length === 0) {
            return null;
        }

        const slots = shifts.filter(
            slot => slot?.date === date && slot?.shiftHourId.toString() === shiftHourId?.toString()
        );

        const currentPoolSlots = slots?.filter(slot => slot?.isInCurrentPool) || [];
        const otherPoolSlots = slots?.filter(slot => !slot?.isInCurrentPool) || [];
        return {currentPoolSlots, otherPoolSlots};
    };

    const changePoolId = ({poolId}) => {
        setFilters({...filters, poolId});
    };

    const getSlotData = ({shiftHourId, date}) => {
        return dailySlots.find(slot => slot?.shiftHourId === shiftHourId && slot?.date === date);
    };

    const bookSlotByDateAndHour = async ({poolId, date, hourId, courierId}) => {
        try {
            const result = await stores.poolShiftStore.bookSlotByDateAndHour({
                poolId,
                date,
                hourId,
                courierId
            });
            recall();
        } catch {}
    };
    const cancelSlotBookingByDateAndHour = async ({poolId, date, hourId, courierId}) => {
        try {
            const result = await stores.poolShiftStore.cancelSlotByDateAndHour({
                poolId,
                date,
                hourId,
                courierId
            });
            recall();
        } catch {}
    };

    const renderOtherPoolLink = ({otherPoolSlots = []}) => {
        return otherPoolSlots?.map(slot => (
            <OtherPoolLink
                key={slot?.date + slot?.shiftHourId}
                onClick={() =>
                    changePoolId({
                        poolId: slot?.poolId
                    })
                }
            >
                {slot?.poolName}
                <br />
            </OtherPoolLink>
        ));
    };

    const calculateDurationRatio = ({actualDuration, plannedDuration}) => {
        return actualDuration && plannedDuration > 0
            ? parseFloat((actualDuration / plannedDuration) * 100)?.toFixed(1)
            : 0;
    };
    const renderShiftReport = shiftReport => {
        return shiftReport ? (
            <>
                <br />
                <br />
                <div>
                    <div>
                        <b>Planlanan Süre:</b> {shiftReport?.plannedDuration} dk
                    </div>
                    <div>
                        <b>Gerçekleşen Süre:</b> {shiftReport?.actualDuration} dk
                    </div>
                    <div>
                        <b>Çalışma Yüzdesi:</b>{" "}
                        {calculateDurationRatio({
                            actualDuration: shiftReport?.actualDuration,
                            plannedDuration: shiftReport?.plannedDuration
                        })}{" "}
                        %
                    </div>
                </div>
            </>
        ) : null;
    };
    const renderSlotTooltipTitle = ({
        currentPoolSlotExists = false,
        otherPoolSlotExists = false,
        ortherPoolSlots = [],
        shiftReport,
        isJoker = false
    }) => {
        if (currentPoolSlotExists && !otherPoolSlotExists) {
            return (
                <>
                    Bu havuzda {isJoker ? "joker" : ""} vardiyası var.
                    {renderShiftReport(shiftReport)}
                </>
            );
        }
        if (!currentPoolSlotExists && otherPoolSlotExists) {
            return (
                <>
                    Başka havuzda vardiyası var. {renderShiftReport(shiftReport)}
                    {renderOtherPoolLink({
                        otherPoolSlots: ortherPoolSlots
                    })}
                </>
            );
        }
        if (currentPoolSlotExists && otherPoolSlotExists) {
            return (
                <>
                    Hem bu havuzda, hem de başka havuzda vardiyası var.{" "}
                    {isJoker ? "Bu havuzda joker vardiyası var." : ""}
                    {renderShiftReport(shiftReport)}
                    {renderOtherPoolLink({
                        otherPoolSlots: ortherPoolSlots
                    })}
                </>
            );
        }
    };
    const renderSlotIcon = ({
        currentPoolSlotExists = false,
        otherPoolSlotExists = false,
        isJoker = false
    }) => {
        const JOKER_COLOR = "#c25368";
        if (currentPoolSlotExists && !otherPoolSlotExists) {
            return <ThunderboltFilled style={{color: isJoker ? JOKER_COLOR : "green"}} />;
        }
        if (!currentPoolSlotExists && otherPoolSlotExists) {
            return <ThunderboltFilled style={{color: "orange"}} />;
        }
        if (currentPoolSlotExists && otherPoolSlotExists) {
            return (
                <>
                    <ThunderboltFilled style={{color: isJoker ? JOKER_COLOR : "green"}} />
                    <ThunderboltFilled style={{color: "orange"}} />
                </>
            );
        }
    };

    const openOperationModal = ({courierId, fullname}) => {
        setOperationModalVisibility(true);
        setCourierId(courierId);
        setFullname(fullname);
    };
    const closeOperationModal = () => {
        setOperationModalVisibility(false);
        setCourierId();
        setFullname();
        setDateOptions([]);
    };

    const openSelectJokerModal = ({dateOptions}) => {
        setSelectJokerModalVisibility(true);
        setDateOptions(dateOptions);
    };
    const closeSelectJokerModal = () => {
        setSelectJokerModalVisibility(false);
        setDateOptions([]);
    };

    const openBookMultipleSlotsModal = ({dateOptions = []}) => {
        setBookMultipleSlotsModalVisibility(true);
        setDateOptions(dateOptions);
    };
    const closeBookMultipleSlotsModal = () => {
        setBookMultipleSlotsModalVisibility(false);
        setDateOptions([]);
    };

    const generateSlotColumns = () => {
        const courierColumn = () => {
            return (
                <TableContainer.Column
                    dataIndex="fullname"
                    key="fullname"
                    title={"Kurye"}
                    fixed="left"
                    width={150}
                    style={{width: "100%", fontSize: "10px !important"}}
                    render={(fullname, courier) => {
                        return (
                            <CourierNameCell data-testid="courierFullname">
                                {stores.meStore.checkRole("isAdmin") && (
                                    <JokerCellOverlay
                                        onClick={() => {
                                            openOperationModal({
                                                courierId: courier?._id,
                                                fullname
                                            });
                                        }}
                                    >
                                        <div></div>
                                        <span>{"İŞLEM YAP"}</span>
                                    </JokerCellOverlay>
                                )}
                                <span data-testid="courierFullname">{fullname}</span>
                            </CourierNameCell>
                        );
                    }}
                />
            );
        };

        const slotColumns = allDates.map((item, index) => {
            const slot = getSlotData({shiftHourId: item?.hour?._id, date: item?.date});

            let isSlotPast = null;
            const currentDatetime = moment().tz("Europe/Istanbul");
            const currentDate = currentDatetime.format("YYYY-MM-DD");
            const currentHour = currentDatetime.format("HH:mm");
            if (currentDate > item.date) {
                isSlotPast = true;
            } else if (
                currentDate === item.date &&
                currentHour > item.hour.endTime &&
                item.hour.endTime !== "00:00"
            ) {
                isSlotPast = true;
            } else {
                isSlotPast = false;
            }
            const canCreateSlot =
                !isSlotPast && dailySlots?.length > 0 && stores.meStore.checkRole("isAdmin");
            return (
                <TableContainer.Column
                    dataIndex="_id"
                    key={item?.date + item?.hour?._id}
                    fixed={index === 0 ? "top" : undefined}
                    className={`pool-corier-shift-slot-column ${slot ? "" : "slot-not-available"}`}
                    title={() => {
                        return (
                            <SlotTitleWrapper>
                                <ShiftHourWrapper>
                                    <ShiftStartHour>{item?.hour?.startTime}</ShiftStartHour>
                                    <ShiftEndHour>{item?.hour?.endTime}</ShiftEndHour>
                                </ShiftHourWrapper>

                                <SlotCellWrapper>
                                    {slot ? (
                                        <SlotCell
                                            hover={false}
                                            totalBooked={slot?.totalBooked}
                                            mode="light"
                                        />
                                    ) : (
                                        <SlotCreatePopConfirm
                                            poolId={filters?.poolId}
                                            forecastDate={filters?.date.format("YYYY-MM-DD")}
                                            slotDate={item?.date}
                                            hourId={item?.hour?._id}
                                            recall={recall}
                                            disabled={!canCreateSlot}
                                        >
                                            <div>
                                                <EmptySlotCell
                                                    content="-"
                                                    hoverContent="Slot Oluştur"
                                                    disabled={!canCreateSlot}
                                                />
                                            </div>
                                        </SlotCreatePopConfirm>
                                    )}
                                </SlotCellWrapper>
                            </SlotTitleWrapper>
                        );
                    }}
                    align="center"
                    width={80}
                    style={{width: "100%", fontSize: "10px !important", padding: "0px !important"}}
                    render={(_, courier) => {
                        const courierId = courier?._id;
                        const date = item?.date;
                        const shiftHourId = item?.hour?._id;
                        const slotData = findInSlotsData({courierId, date, shiftHourId});
                        const currentPoolSlotExists = slotData?.currentPoolSlots?.length > 0;
                        const otherPoolSlotExists = slotData?.otherPoolSlots?.length > 0;
                        const shiftReport = currentPoolSlotExists
                            ? slotData?.currentPoolSlots[0]?.shiftReport
                            : null;
                        const isJoker = currentPoolSlotExists
                            ? slotData?.currentPoolSlots.some(slot => slot?.isJoker)
                            : false;

                        const canNotEditable = !slot || isSlotPast;
                        const canChangeCourier =
                            slot &&
                            !isSlotPast &&
                            stores.meStore.checkRole("poolCourierShiftBooking") &&
                            stores.meStore.checkPermission("poolCourierShifts.bookSlot");
                        return (
                            <ShiftCell data-testid="slot" disabled={canNotEditable}>
                                {canChangeCourier ? (
                                    <Tooltip
                                        title={renderSlotTooltipTitle({
                                            currentPoolSlotExists,
                                            otherPoolSlotExists,
                                            ortherPoolSlots: slotData?.otherPoolSlots,
                                            shiftReport,
                                            isJoker
                                        })}
                                    >
                                        <SlotCellOverlay
                                            onClick={() => {
                                                if (currentPoolSlotExists) {
                                                    cancelSlotBookingByDateAndHour({
                                                        poolId: filters?.poolId,
                                                        date,
                                                        hourId: shiftHourId,
                                                        courierId
                                                    });
                                                } else {
                                                    bookSlotByDateAndHour({
                                                        poolId: filters?.poolId,
                                                        date,
                                                        hourId: shiftHourId,
                                                        courierId
                                                    });
                                                }
                                            }}
                                        >
                                            <div></div>
                                            <span>{currentPoolSlotExists ? "İPTAL" : "EKLE"}</span>
                                        </SlotCellOverlay>
                                    </Tooltip>
                                ) : (
                                    <></>
                                )}
                                {slot ? (
                                    <Tooltip
                                        title={renderSlotTooltipTitle({
                                            currentPoolSlotExists,
                                            otherPoolSlotExists,
                                            ortherPoolSlots: slotData?.otherPoolSlots,
                                            shiftReport,
                                            isJoker
                                        })}
                                    >
                                        <ShiftIconWrapper>
                                            {renderSlotIcon({
                                                currentPoolSlotExists,
                                                otherPoolSlotExists,
                                                isJoker
                                            })}
                                        </ShiftIconWrapper>
                                    </Tooltip>
                                ) : (
                                    <></>
                                )}
                                {shiftReport ? (
                                    <DurationProgressWrapper>
                                        <CustomProgress
                                            height="5px"
                                            progress={
                                                calculateDurationRatio({
                                                    actualDuration: shiftReport?.actualDuration,
                                                    plannedDuration: shiftReport?.plannedDuration
                                                }) || 0
                                            }
                                        />
                                    </DurationProgressWrapper>
                                ) : (
                                    <></>
                                )}
                            </ShiftCell>
                        );
                    }}
                />
            );
        });

        return [courierColumn(), ...slotColumns];
    };

    const shiftFilter = courierShift => {
        /* Genel En Az Bir Vardiya Seçmişler */
        if (filters?.courierShiftSelectionCount === "atLeastOneShiftGeneral") {
            if (courierShift?.totalBooked === 0) {
                return false;
            }
        }

        /* Bu Havuzda En Az Bir Vardiya Seçmişler */
        if (filters?.courierShiftSelectionCount === "atLeastOneShiftThisPool") {
            if (courierShift?.totalBookedInPool === 0) {
                return false;
            }
        }

        /* Genel Vardiya Seçmemişler */
        if (filters?.courierShiftSelectionCount === "noShiftGeneral") {
            if (courierShift?.totalBooked > 0) {
                return false;
            }
        }

        /* Bu Havuzda Vardiya Seçmemişler */
        if (filters?.courierShiftSelectionCount === "noShiftThisPool") {
            if (courierShift?.totalBookedInPool > 0) {
                return false;
            }
        }

        return true;
    };

    return (
        <>
            <TableContainer
                className={TABLE_PREFIX}
                rowClassName={`${TABLE_PREFIX}-row`}
                pagination={false}
                locale={{
                    emptyText: <EmptyMessage />
                }}
                rowKey="_id"
                dataSource={courierShifts?.filter(shiftFilter)}
                data-testid="poolDataTable"
                loading={loading}
                size="small"
                scroll={{x: 1200, y: 800}}
                style={{width: "100%", fontSize: "10px !important"}}
                bordered
            >
                {generateSlotColumns()}
            </TableContainer>

            <Modal
                title={"İşlem Yap"}
                visible={operationModalVisibility}
                onOk={closeOperationModal}
                onCancel={closeOperationModal}
                okText={t("modal.okButton", {ns: "common"})}
                cancelText={t("modal.cancelButton2", {ns: "common"})}
            >
                <Row>
                    <b style={{marginRight: "5px"}}>{fullname}</b> isimli kurye için işlem seçiniz.
                </Row>
                <Row gutter={[16, 16]} style={{marginTop: "10px"}}>
                    <Col span="auto">
                        <Button
                            onClick={() => {
                                setBookMultipleSlotsModalVisibility(false);
                                openSelectJokerModal({dateOptions: allDates || []});
                            }}
                        >
                            Joker Tanımlaması Yap
                        </Button>
                    </Col>
                    <Col span="auto">
                        <Button
                            onClick={() => {
                                setSelectJokerModalVisibility(false);
                                openBookMultipleSlotsModal({
                                    dateOptions:
                                        allDates.filter(date =>
                                            dailySlots.some(
                                                slot => date.hour._id === slot.shiftHourId
                                            )
                                        ) || []
                                });
                            }}
                        >
                            Toplu Vardiya Atama
                        </Button>
                    </Col>
                </Row>
            </Modal>
            <SelectJokerModal
                visibility={selectJokerModalVisibility}
                onChangeVisibility={closeSelectJokerModal}
                courierId={courierId}
                courierFullname={fullname}
                poolId={filters?.poolId}
                date={filters?.date ? filters?.date.format("YYYY-MM-DD") : undefined}
                recall={recall}
                dateOptions={dateOptions || []}
            />
            <BookMultipleSlotsModal
                visibility={bookMultipleSlotsModalVisibility}
                onChangeVisibility={closeBookMultipleSlotsModal}
                courierId={courierId}
                courierFullname={fullname}
                poolId={filters?.poolId}
                date={filters?.date ? filters?.date.format("YYYY-MM-DD") : undefined}
                recall={recall}
                dateOptions={dateOptions || []}
            />
        </>
    );
};

export default ResponsiveDataTable;
